import { ObjectUpdatedType } from '@/enums/ObjectUpdatedType.enum';
import { UserHelper } from '@/helpers/user.helper';
import { AlertService } from '@/services/alert.service';
import { AppConfigService } from '@/services/app-config.service';
import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MarketPlaceService, PropertyCustomService, RealProperty } from '@eemo/api-client';
import { Subscription } from 'rxjs';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import {
  PropertyCustomServicesDialogComponent,
  PropertyCustomServicesDialogData
} from '../property-custom-services-dialog/property-custom-services-dialog.component';
import { FullAddressPipe } from '../../extensions/full-address.pipe';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-property-custom-services',
    templateUrl: './property-custom-services.component.html',
    styleUrls: ['./property-custom-services.component.scss'],
    standalone: true,
    imports: [NgIf, MatTableModule, MatSortModule, MatButtonModule, MatMenuModule, MatIconModule, FullAddressPipe]
})
export class PropertyCustomServicesComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(MatSort) sort: MatSort;
  @Input() prop: RealProperty;

  dataSource: MatTableDataSource<PropertyCustomService>;
  displayFullColumns = false;
  tableClass = 'light';
  displayedColumns = ['name', 'summary', 'fullAddress', 'email', 'phoneNumber', 'website' /*'contact',*/];
  canShowAdd = false;
  getServicesSub = new Subscription();
  deleteServicesSub = new Subscription();
  canUpdateProperty = false;
  objectUpdateSub = new Subscription();

  constructor(
    private dialog: MatDialog,
    private marketPlaceService: MarketPlaceService,
    private userHelper: UserHelper,
    private appConfigService: AppConfigService,
    private alertService: AlertService
  ) {
    this.prop = this.appConfigService.selectedProp;
    this.canUpdateProperty = this.userHelper.canUpdateProperty(this.prop);
    this.canShowAdd = userHelper.isAdmin() || userHelper.isRealEstate();
  }

  ngOnInit() {
    if (this.canUpdateProperty) {
      this.displayedColumns.push('actions');
    }
    this.loadData();
    this.objectUpdateSub = this.appConfigService.objectUpdated.subscribe((type) => {
      if (type === ObjectUpdatedType.CUSTOM_CONTACT) {
        this.loadData();
      }
    });
  }

  ngOnDestroy(): void {
    this.getServicesSub.unsubscribe();
    this.deleteServicesSub.unsubscribe();
    this.objectUpdateSub.unsubscribe();
  }

  loadData() {
    let filter: string;
    if (this.dataSource && this.dataSource.filter) {
      filter = this.dataSource.filter;
    }
    // TODO manage pagination
    this.getServicesSub = this.marketPlaceService.getPropertyCustomServices(this.prop.uid).subscribe((data) => {
      this.dataSource = new MatTableDataSource(data);
      // *ngIf break the sort : must be set in background
      setTimeout(() => (this.dataSource.sort = this.sort));
      if (filter) {
        this.applyFilter(filter);
      }
    });
  }

  ngAfterViewInit() {}

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  add() {
    // prevents to open multiple dialog
    if (this.dialog.openDialogs.length === 0) {
      const data: PropertyCustomServicesDialogData = { property: this.prop, edition: false };
      const dialogRef = this.dialog.open(PropertyCustomServicesDialogComponent, {
        data
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.loadData();
        }
      });
    }
  }

  edit(propertyCustomServiceToEdit: PropertyCustomService) {
    // prevents to open multiple dialog
    if (this.dialog.openDialogs.length === 0) {
      const data: PropertyCustomServicesDialogData = {
        property: this.prop,
        customService: propertyCustomServiceToEdit,
        edition: true
      };
      const dialogRef = this.dialog.open(PropertyCustomServicesDialogComponent, {
        data
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.loadData();
        }
      });
    }
  }

  confirmDelete(customService: PropertyCustomService) {
    // prevents to open multiple dialog
    if (this.dialog.openDialogs.length === 0) {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        // width: '25rem',
        data: {
          message: 'Confirmez-vous la suppression du service "' + customService.name + '" ?'
        }
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.doDelete(customService);
        }
      });
    }
  }

  doDelete(customService: PropertyCustomService) {
    this.deleteServicesSub = this.marketPlaceService
      .deletePropertyCustomService(this.prop.uid, customService.uid)
      .subscribe((result) => {
        this.alertService.success('Suppression effectuée avec succès');
        this.loadData();
      });
  }
}
